import { showUsaFeature } from './app';
import { defaultMeasurementIndicators } from './measurement';
import { Indicator } from './models';

export const reportMeasurementIndicators = showUsaFeature
  ? defaultMeasurementIndicators.filter((i) => i !== Indicator.Quality)
  : defaultMeasurementIndicators;

export const initialReportContentSetting: Record<Indicator, number> = reportMeasurementIndicators.reduce(
  (p, n) => ({ ...p, [n]: 0 }),
  {} as Record<Indicator, number>,
);
